module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "exp-layout"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "l_experiment",
    attrs: {
      "md-column": "",
      "md-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "7%",
      "position": "absolute",
      "top": "2%"
    },
    attrs: {
      "src": require("../assets/chemistryAI_logo.png")
    }
  })]), _vm._v(" "), (_vm.experiment_type === 2 && _vm.emotive_device == '') ? _c('span', {
    staticClass: "emo_state_device"
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.experiment_type === 2 && !_vm.loaded) ? _c('div', [_c('center', [_c('span', {
    staticClass: "md-display-1 fade-in"
  }, [_vm._v("\n        Please connect Emotiv Epoc+ to start the Experiment.\n      ")])])], 1) : (!_vm.loaded) ? _c('div', [_c('center', [_c('span', {
    staticClass: "md-display-1 fade-in"
  }, [_vm._v("\n        loading ...\n       ")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.mols), function(molecule, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.loaded && index === _vm.moleculeIndex),
        expression: "loaded && index === moleculeIndex"
      }],
      key: index,
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.moleculeIndex),
        expression: "index === moleculeIndex"
      }],
      staticStyle: {
        "height": "100%"
      }
    }, [_c('img', {
      staticClass: "fade-in-fast",
      staticStyle: {
        "height": "90%",
        "border-radius": "25px",
        "flex": "1"
      },
      attrs: {
        "src": '/static/mol/' + molecule.name + '.png'
      }
    }), _vm._v(" "), _c('div', [(_vm.show_emo_state && _vm.experiment_type === 2) ? _c('div', {
      staticClass: "emo_state"
    }, [(_vm.emotive_device == '') ? _c('p', [_c('md-spinner', {
      staticClass: "md-accent",
      attrs: {
        "md-size": 20,
        "md-indeterminate": ""
      }
    }), _vm._v(" waitng for device ...\n        ")], 1) : _c('p', [_vm._v("\n          " + _vm._s(_vm.emotive_device) + "\n          "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.interest
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.stress
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.relaxation
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.excitement
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.engagement
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.long_term_excitement
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.focus
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('center', [(_vm.experiment_type != 2) ? _c('md-button', {
      staticClass: "md-raised md-primary like_button",
      on: {
        "click": function($event) {
          return _vm.rate(molecule.id, molecule.design, _vm.moleculeIndex, 0)
        }
      }
    }, [(_vm.experiment_type == 0) ? _c('span', [_vm._v("Like")]) : _c('span', [_vm._v("Human")])]) : _vm._e(), _vm._v(" "), (_vm.experiment_type != 2) ? _c('md-button', {
      staticClass: "md-raised md-warn dislike_button",
      on: {
        "click": function($event) {
          return _vm.rate(molecule.id, molecule.design, _vm.moleculeIndex, 1)
        }
      }
    }, [(_vm.experiment_type == 0) ? _c('span', [_vm._v("Dislike")]) : _c('span', [_vm._v("GAN")])]) : _vm._e()], 1)], 1)])])
  }), _vm._v(" "), (false) ? _c('md-layout', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moleculeIndex === _vm.mols.length),
      expression: "moleculeIndex === mols.length"
    }]
  }, [_c('h2', [_vm._v("Done!")]), _vm._v(" "), (_vm.experiment_type == 0) ? _c('p', [_vm._v("\n    results: Human Liked: " + _vm._s(_vm.humanLiked) + ". GAN Liked: " + _vm._s(_vm.ganLiked) + "\n    ")]) : _c('p', [_vm._v("\n    results: Right: " + _vm._s(_vm.guessedRight) + ". Wrong: " + _vm._s(_vm.guessedWrong) + "\n    ")])])]) : _vm._e()], 2), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f6cb4ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Experiment.vue
// module id = 343
// module chunks = 1